module.exports = __webpack_public_path__ + "img/close_round.aa7d6f69.png";